import { withSvgIcon } from './withSvgIcon';

export const Bank = withSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M11.5528 5.34166C11.8343 5.20089 12.1657 5.20089 12.4472 5.34166L15.7639 7.00002H8.23604L11.5528 5.34166ZM13.3416 3.5528C12.497 3.13051 11.5029 3.13051 10.6583 3.5528L3.55276 7.10559C3.13795 7.313 2.92017 7.7784 3.02673 8.22977C3.13328 8.68114 3.5362 9.00002 3.99998 9.00002H20C20.4638 9.00002 20.8667 8.68114 20.9732 8.22977C21.0798 7.7784 20.862 7.313 20.4472 7.10559L13.3416 3.5528ZM6.99998 11V10H4.99998V11V17V18H6.99998V17V11ZM15 10V11V17V18H13V17V11V10H15ZM19 11V10H17V11V17V18H19V17V11ZM3.99998 19H4.99998H19H20V21H19H4.99998H3.99998V19ZM11 11V10H8.99998V11V17V18H11V17V11Z"
    fill="currentColor"
  />,
  { viewBox: '0 0 24 24' },
);
